// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__3-WUN","empty":"ModalGraph_empty__3_6ak"};